import { render, staticRenderFns } from "./TrukkinOneFrame.vue?vue&type=template&id=e22af556&scoped=true&"
import script from "./TrukkinOneFrame.vue?vue&type=script&lang=js&"
export * from "./TrukkinOneFrame.vue?vue&type=script&lang=js&"
import style0 from "./TrukkinOneFrame.vue?vue&type=style&index=0&id=e22af556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22af556",
  null
  
)

export default component.exports